import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TableCell,
  TableRow,
  Checkbox,
  Typography,
  IconButton,
  Tooltip,
  Fade,
} from '@material-ui/core';
import { FileCopyOutlined as CopyIcon, ExpandMore as ExpandIcon } from '@material-ui/icons';
import classNames from 'classnames';

const styles = {
  tableRow: {
    height: 40,
  },
  expandableRow: {
    userSelect: 'none',
    cursor: 'pointer',
  },
  checkbox: {
    padding: 8,
    margin: '0 4px',
  },
  copy: {
    left: -7,
  },
  expand: {
    transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  expanded: {
    transform: 'rotate(180deg)',
  },
  group: {
    transition: 'background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  grouped: {
    backgroundColor: '#e8f5ff',
  },
  tableHead: {
    color: 'rgba(0, 0, 0, 0.54) !important',
    fontSize: '0.75rem !important',
    fontWeight: '500 !important',
  },
};

class BillOfLadingDetail extends React.PureComponent {
  state = {
    expanded: false,
    visible: false,
  };

  hasEquipment = () => {
    return !!this.props.detail.equipment.length;
  }

  handleExpand = event => {
    event.stopPropagation();

    if (!this.hasEquipment()) {
      return;
    } 

    if (this.state.expanded) {
      this.setState({ visible: false });
      setTimeout(() => this.setState({ expanded: false, visible: false }), 150);
    } else {
      this.setState({ expanded: true, visible: true });
    }
  };

  renderCommodity = detail => {
    const { commodity } = detail;

    if (commodity.length <= 30) {
      return (
        <TableCell component="th" scope="row">
          {commodity}
        </TableCell>
      );
    }

    return (
      <Tooltip title={commodity}>
        <TableCell component="th" scope="row">
          <Typography>{commodity.slice(0, 30)}...</Typography>
        </TableCell>
      </Tooltip>
    );
  };

  render() {
    const { visible, expanded } = this.state;
    const { detail, isSelected, handleSelect, handleCopy, classes } = this.props;

    return (
      <React.Fragment>
        <TableRow
          role="checkbox"
          aria-checked={isSelected}
          tabIndex={-1}
          onClick={this.handleExpand}
          selected={isSelected}
          className={classNames(classes.tableRow, classes.expandableRow)}
        >
          <TableCell padding="checkbox">
            <Checkbox
              checked={isSelected}
              className={classes.checkbox}
              onClick={event => handleSelect(event, detail.itemNumber)}
            />
          </TableCell>
          <TableCell component="th" scope="row">
            {detail.itemNumber}
          </TableCell>
          <TableCell component="th" scope="row">
            {detail.packageType}
          </TableCell>
          <TableCell component="th" scope="row">
            {detail.quantity}
          </TableCell>
          {this.renderCommodity(detail)}
          <TableCell component="th" scope="row">
            {detail.grossWeight} {detail.grossWeightUnit}
          </TableCell>
          <TableCell component="th" scope="row">
            {detail.customsStatus}
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classNames(classes.group, visible && classes.grouped)}
          >
            <Tooltip title="Show Equipment">
              <IconButton
                className={classNames(classes.copy, classes.expand, visible && classes.expanded)}
                aria-label="Show Equipment"
                disabled={!this.hasEquipment()}
              >
                <ExpandIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
          <TableCell component="th" scope="row">
            <Tooltip title="Copy">
              <IconButton
                className={classes.copy}
                aria-label="Copy"
                onClick={event => {
                  event.stopPropagation();
                  handleCopy(detail);
                }}
              >
                <CopyIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
        {expanded ? (
          <React.Fragment>
            <Fade in={visible} timeout={200}>
              <TableRow className={classes.tableRow}>
                <TableCell padding="checkbox" />
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  Equipment Type
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  Identifier
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  Size Type
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  FCL/LCL
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  Stuffing
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)}>
                  Weight
                </TableCell>
                <TableCell className={classNames(classes.tableHead, classes.grouped)} />
                <TableCell />
              </TableRow>
            </Fade>
            {detail.equipment.map(equipment => (
              <Fade in={visible} timeout={200} key={equipment.identifier}>
                <TableRow className={classes.tableRow}>
                  <TableCell padding="checkbox" />
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.equipmentType}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.identifier}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.sizeType}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.transportCondition}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.stuffing}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped}>
                    {equipment.vgmWeight} {equipment.vgmWeightUnit}
                  </TableCell>
                  <TableCell component="th" scope="row" className={classes.grouped} />
                  <TableCell component="th" scope="row" />
                </TableRow>
              </Fade>
            ))}
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

BillOfLadingDetail.propTypes = {
  detail: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleCopy: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BillOfLadingDetail);
